import React, { useState } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import SupportSection from '../components/SupportForms';

function SupportPage() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} isHeader={true} />
            <Navbar toggle={toggle} isHeader={true} />
            <SupportSection />
            <Footer />
        </>
    );
}

export default SupportPage;

